import React, { useEffect, useState } from "react";

const PdfPreview = ({
  avater,
  firstName,
  lastName,
  email,
  phone,
  jobTitle,
  country,
  city,
  address,
  postalCode,
  drivingLicense,
  nationality,
  dateOfBirth,
  professionalSummery,
  interest,
  skills,
  links,
  employmentHistory,
  educations,
}) => {
  const [hasLink, setHasLink] = useState(false);
  const [hasEducation, setHasEducation] = useState(false);
  const [hasHistory, setHasHistory] = useState(false);

  useEffect(() => {
    employmentHistory.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "") {
          setHasHistory(true);
        }
      });
    });
  }, [employmentHistory]);

  useEffect(() => {
    educations.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "") {
          setHasEducation(true);
        }
      });
    });
  }, [educations]);

  useEffect(() => {
    links.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "") {
          setHasLink(true);
        }
      });
    });
  }, [links]);

  const skillArr = skills.split(",");
  // const isLinksEmpty = links.some(link => link.title === '' && link.value === '');

  return (
    <>
      <div className="flex gap-3 px-14 py-10 flex-1 overflow-auto bg-white rounded-md">
        <div className="basis-44 shrink-0 grow-0">
          <div className="rounded-full h-20 w-20 overflow-hidden">
            <img src={avater} alt="" />
          </div>
          {(address ||
            phone ||
            email ||
            postalCode ||
            drivingLicense ||
            nationality ||
            dateOfBirth ||
            country ||
            city) && (
            <div className="mt-8">
              <h4 className="text-golden text-lg font-normal mb-4">Details</h4>
              {(address || city || postalCode || country) && (
                <div className="mb-4">
                  <p className="text-xs text-slate-900 mb-1">Address</p>
                  <p className="text-xs text-slate-500">{address}</p>
                  <p className="text-xs text-slate-500">
                    {city} {postalCode}
                  </p>
                  <p className="text-xs text-slate-500">{country}</p>
                </div>
              )}
              {phone && (
                <div className="mb-4">
                  <p className="text-xs text-slate-900 mb-1">Phone</p>
                  <p className="text-xs text-slate-500">{phone}</p>
                </div>
              )}
              {email && (
                <div className="mb-4">
                  <p className="text-xs text-slate-900 mb-1">Email</p>
                  <p className="text-xs text-slate-500">{email}</p>
                </div>
              )}
              {drivingLicense && (
                <div className="mb-4">
                  <p className="text-xs text-slate-900 mb-1">Driving License</p>
                  <p className="text-xs text-slate-500">{drivingLicense}</p>
                </div>
              )}
              {dateOfBirth && (
                <div className="mb-4">
                  <p className="text-xs text-slate-900 mb-1">Date of Birth</p>
                  <p className="text-xs text-slate-500">{dateOfBirth}</p>
                </div>
              )}
              {nationality && (
                <div className="mb-4">
                  <p className="text-xs text-slate-900 mb-1">Nationality</p>
                  <p className="text-xs text-slate-500">{nationality}</p>
                </div>
              )}
            </div>
          )}

          {hasLink && (
            <div className="mt-8">
              <h4 className="text-golden text-lg font-normal mb-4">Links</h4>
              <div className="mb-4">
                {links.map((link, index) => (
                  <div className="text-xs text-golden mb-2" key={index}>
                    <a target="_blank" rel="noreferrer" href={link.value}>
                      {link.title}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}

          {skills && (
            <div className="mt-8">
              <h4 className="text-golden text-lg font-normal mb-4">Skills</h4>
              <div className="mb-4">
                {skillArr.map((skill, index) => (
                  <p key={index} className="text-xs text-slate-900 mb-2">
                    {skill}
                  </p>
                ))}
              </div>
            </div>
          )}

          {interest && (
            <div className="mt-8">
              <h4 className="text-golden text-lg font-normal mb-4">Interest</h4>
              <div className="mb-4">
                <p className="text-xs text-slate-900 mb-2">{interest}</p>
              </div>
            </div>
          )}
        </div>
        <div className="flex-1">
          {(firstName || lastName || jobTitle) && (
            <div className="mb-12">
              {(firstName || lastName) && (
                <h2 className="text-3xl font-normal text-slate-900">
                  {firstName} {lastName}
                </h2>
              )}
              {jobTitle && (
                <p className="text-sm mt-1 text-slate-400 pb-1">{jobTitle}</p>
              )}
            </div>
          )}

          {professionalSummery && (
            <div className="mb-8">
              <h4 className="text-golden text-lg font-normal mb-4">Profile</h4>
              <p className="text__default">{professionalSummery}</p>
            </div>
          )}

          {hasHistory ? (
            <div className="mb-8">
              <h4 className="text-golden text-lg font-normal mb-4">
                Employment History
              </h4>
              {employmentHistory.map((history, index) => (
                <div className="mb-4" key={index}>
                  <p className="text-slate-900 text-sm">
                    {history.prevDesignation}
                    {history.prevDesignation && history.prevCompany ? ", " : ""}
                    {history.prevCompany}
                  </p>
                  <p className="text-xs text-slate-900 mt-1">
                    <span>
                      {history.startDate ? history.startDate : ""} to{" "}
                      {history.endDate ? history.endDate : ""}
                    </span>
                    -
                    <span className="text-slate-500">
                      {history.jobLocations ? history.jobLocations : ""}
                    </span>
                  </p>
                  {history.JobDescription && (
                    <p className="text__default mt-2">
                      {history.JobDescription}
                    </p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            ""
          )}

          {hasEducation && (
            <div className="mb-8">
              <h4 className="text-golden text-lg font-normal mb-4">
                Education
              </h4>
              {educations.map((education, index) => (
                <div className="mb-4" key={index}>
                  <p className="text-slate-900 text-sm">
                    {education.instituteName}, {education.degree}
                  </p>
                  <p className="text-xs text-slate-900 mt-1">
                    <span>{education.passingYear}</span> -{" "}
                    <span className="text-slate-500">
                      {education.degreeLocation}
                    </span>
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PdfPreview;
